function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// return
export function whenMapMetricsToPropsIsFunction(data) {
  return typeof data === 'function' ? data : undefined; //eslint-disable-line no-undefined
}

// just return the d
export function whenMapMetricsToPropsIsAnObject(data) {
  if (_typeof(data) === 'object') {
    return function () {
      return data;
    };
  }
  return undefined; // eslint-disable-line
}

export default [whenMapMetricsToPropsIsFunction, whenMapMetricsToPropsIsAnObject];
//# sourceMappingURL=mapMetricsToProps.js.map